/**
 * Extrai emails de um arquivo de roster (.csv / .json / texto solto).
 *
 * Estratégia uniforme: quebra o conteúdo em tokens (vírgula, espaço,
 * aspas, colchetes, etc.) e classifica cada um. Funciona pra array JSON
 * `["a@x.com"]`, `{ "emails": [...] }`, array de objetos, CSV com
 * cabeçalho, ou um email por linha — sem parser específico de formato.
 */

/** Email "limpo" — sem espaços, com @ e domínio. */
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export interface ParsedRoster {
  /** Emails válidos, normalizados (lowercase) e deduplicados. */
  emails: string[]
  /** Tokens que pareciam email (têm @) mas não passaram na validação. */
  rejected: string[]
}

export function parseRosterFile(text: string): ParsedRoster {
  const tokens = text
    .split(/[\s,;"'[\]{}()]+/)
    .map((t) => t.trim())
    .filter(Boolean)

  const emails = new Set<string>()
  const rejected: string[] = []

  for (const token of tokens) {
    if (EMAIL_RE.test(token)) {
      emails.add(token.toLowerCase())
    } else if (token.includes('@')) {
      rejected.push(token)
    }
    // tokens sem @ (cabeçalho de CSV, chave "emails" do JSON) são ignorados
  }

  return { emails: [...emails], rejected }
}
